import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-surface/30 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="font-heading text-2xl lg:text-3xl font-bold text-white tracking-tight">
              Ready to build your vision into reality?
            </h2>
            <p className="text-slate-400 mt-2 text-sm">
              Let's discuss how we can help transform your business.
            </p>
          </div>
          <Link
            to="/contact"
            className="btn-amber rounded-sm text-sm inline-flex items-center gap-2 whitespace-nowrap"
          >
            Contact Us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
